var _defs, _path, _path2, _path3, _path4, _path5, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeruxTextoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1463.36 709.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}.cls-3{font-size:62.4px;font-family:ArialNarrow, Arial;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.76,444.3H274.13v35.51H97.52V444.3L223.46,255.38h-125v-35H273.18v35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.31,366.18H357.93q2.35,38.34,26.27,59.89t58,21.54q27.93,0,46.63-13a68.83,68.83,0,0,0,26.28-34.8h46.4a111.55,111.55,0,0,1-41.66,60.85q-31.26,23.43-77.65,23.43-36.94,0-66-16.57t-45.7-47.11q-16.57-30.54-16.57-70.79T330,279.06a113,113,0,0,1,45.22-46.64q29.12-16.33,67-16.34,36.93,0,65.34,16.1a111.64,111.64,0,0,1,43.79,44.27q15.39,28.19,15.39,63.69A252.73,252.73,0,0,1,565.31,366.18Zm-54-77.42a70.88,70.88,0,0,0-29.59-27,92.38,92.38,0,0,0-41.43-9.23q-32.67,0-55.63,20.83T358.4,331.14H522.22Q522.22,306.53,511.33,288.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M699.07,227.92q21.06-12.3,51.37-12.31v44.51H739.07q-72.44,0-72.44,78.59v141.1H623.55V220.35h43.08v42.13A82.71,82.71,0,0,1,699.07,227.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1030.26,220.35V479.81H987.17V441.46a83.82,83.82,0,0,1-34.33,31q-22,11.13-48.53,11.13-30.3,0-54.45-12.55t-38.11-37.64q-14-25.1-14-61.08v-152h42.61v146.3q0,38.36,19.41,59t53,20.59q34.56,0,54.45-21.3t19.89-62V220.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1238.59,479.81,1177,383.22l-59.18,96.59h-45L1156.67,351l-83.8-130.67h48.77l61.55,96.11,58.71-96.11h45l-83.33,128.31,83.8,131.15Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1350.76,
    cy: 233.67,
    r: 39.06
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1331.89 255.38)"
  }, "R")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeruxTextoBlanco);
export default __webpack_public_path__ + "static/media/zerux-texto-blanco.550c4fee0a02428abb0d4eb7840e39c5.svg";
export { ForwardRef as ReactComponent };